import {
    EVENT_SERVICE,
} from "./../../providers/service.providers";
import { EventService } from "../../services/event.service";
import {
    Component,
    OnInit,
    Inject,
    OnDestroy
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Event } from "../../models/Event";
import { ImageHelper } from "../../helpers/ImageHelper";
import { environment } from "./../../../environments/environment";
import { LabelsService } from "src/app/services/labels.service";
import { SessionCartService } from "./session-cart/session-cart.service";
import { Session } from "src/app/models/Session";
import { ActiveEventService } from "src/app/services/active-event.service";
import { LocalizableError } from 'src/app/models/LocalizableError';
import { EventCheckoutRoutePaths } from "../eventregistration/eventregistration.component";
import { SessionTrack } from "../../models/SessionTrack";
import { Speaker } from "../../models/Speaker";
import { Pass } from '../../models/Pass';
import { time } from 'console';
import { MsTimeZoneIndexValues } from "../../constants/MSTimeZoneIndexValues";
import { TimeDisplayConfig } from '../../../assets/config/config';
import { DatePipe, LocationStrategy } from '@angular/common';
import { DefaultDateFormats } from "../../constants/DefaultDateFormats"
import { DateFormatter } from 'src/app/helpers/DateFormatter';
import { EventRouterService } from 'src/app/services/event-router.service';
import { Observable, Subscription } from 'rxjs';
import { ViewportScroller } from "@angular/common";
import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from "src/app/components/event/data.service";
import { map } from "rxjs/operators";
import Swal from "sweetalert2";


@Component({
    selector: "app-event",
    templateUrl: "./event.component.html",
    styleUrls: ["./event.component.scss"]
})
export class EventComponent implements OnInit, OnDestroy {
    public EventDetailSections = EventDetailSections;
    public readableEventId: string;
    public contactId: string;
    public event: Event;
    public sessions: Session[];
    public showSessions: Boolean;
    public showSpeakers: Boolean;
    public showSessionTracks: Boolean;
    public showPasses: Boolean;
    public selectedSection: EventDetailSections = EventDetailSections.Sessions;
    public isSessionCartCollapsed: Boolean = false;
    public isSessionCartAllowed: Boolean = false;
    public isLoadingData = false;
    public error: LocalizableError;
    public formattedDate: string;
    public price: any;
    public speaker: any;
    public sponsoredEvent: Boolean = false;
    public sponsor: any;
    public selectedSessions: any;
    public eventDate;
    public nowDate;
    public enableAnmeldungButton: Boolean = true;
    sessionsByDay: any;
    dateKeys: string[];
    selectedDateKey: string;
    sessionsCopy: Session[];
    sessionsCopy1: Session[];
    isCollapsed:boolean = true;
    valueCollapse: any;
    OverAllSession: any;
    OverAllSessionCheckbox: any;
    enableMembersConferenceButton: boolean = false; // FLAG THAT ONLY CONFERENCE SESSION IS SELECTED
    buttonFunctionality: String = 'Jahresversammlung';
   


    daysOfWeek: string[] = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];


    private defaultImageUrlSelfHosted = 'default-event-image.jpg';
    private defaultImageUrlCrmHosted = 'homehero.jpg';
    private dataPromise: Promise<any>;

    private eventRouterSubscription: Subscription;
    subscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        @Inject(EVENT_SERVICE) private eventService: EventService,
        private eventRouterService: EventRouterService,
        private imageHelper: ImageHelper,
        private labelsService: LabelsService,
        private sessionCartService: SessionCartService,
        private activeEventService: ActiveEventService,
        private datePipe: DatePipe,
        private vps: ViewportScroller,
        private data: DataService
    ) {
        this.route.queryParamMap.subscribe(paramMap => {
            this.readableEventId = paramMap.get(
                EventQueryParameterNames.ReadableEventId
            );

            this.dataPromise = this.getEventAndSessionData().then(async () => {
                const p4 = this.setIsSessionCartAllowed();

                const p1 = this.eventService.getSessionTracks(this.readableEventId).toPromise().then(
                    tracks => {
                        this.showSessionTracks = tracks && tracks.length > 0;
                        this.eventRouterService.emitSessionTracks(tracks);
                    }
                );
                const p2 = this.eventService.getSpeakers(this.readableEventId).toPromise().then(
                    speakers => {
                        if (speakers && speakers.length>0){
                            this.speaker = speakers
                            // SORT SPEAKERS WITH ALPHABETIC ORDER
                            this.speaker.sort((x, y) => {
                                let a = x.name.toUpperCase(),
                                    b = y.name.toUpperCase();
                                return a == b ? 0 : a > b ? 1 : -1;
                            });

                        }
                        this.showSpeakers = speakers && speakers.length > 0;
                        this.eventRouterService.emitSpeakers(speakers);
                    }
                );
                const p3 = this.eventService.getPasses(this.readableEventId).toPromise().then(
                    passes => {
                        if(passes.length>0){this.price = passes};
                        this.showPasses = passes && passes.length > 0;
                        this.eventRouterService.emitPasses(passes);
                    }
                );

                await Promise.all([p1, p2, p3, p4]);
            });
        });
     }

    ngOnDestroy(): void {
        this.eventRouterSubscription.unsubscribe();
        this.subscription.unsubscribe();
    }

    printPage(){
        window.print();
    }

    async ngOnInit() {
        window.scroll({ 
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
        });

        if(this.route.snapshot.queryParams['cn']) {
            this.contactId = this.route.snapshot.queryParams['cn'];
            localStorage.removeItem('ContactId');
            // localStorage.setItem('ContactId', this.contactId);
            // setTimeout( async () => {
            //     localStorage.removeItem('ContactId')
            // }, 120000);
        }

        this.data.changeMessage([]);
        this.data.changeName([]);
        
        this.eventRouterSubscription = this.eventRouterService.choosePath$.subscribe(() => {
            this.chooseRoute();
        })
        

        this.sessionCartService.isOpen = false;
    }
    public loadSponsors(event) { 
        this.sponsor = event;
        if(event && event.length>0){
            this.sponsoredEvent = true;
        } 
    }
    public chooseRoute() {
        this.dataPromise.then(p => {
            if (this.showSessions) {
                this.router.navigate(["event/sessions"], { queryParams: { id: this.readableEventId } });
            } else if (this.showSessionTracks) {
                this.router.navigate(["event/session-tracks"], { queryParams: { id: this.readableEventId } });
            } else if (this.showSpeakers) {
                this.router.navigate(["event/speakers"], { queryParams: { id: this.readableEventId } });
            } else if (this.showPasses) {
                this.router.navigate(["event/pass-information"], { queryParams: { id: this.readableEventId } });
            }
        })
    }

    public formatStartDate(): string {
        let dateSettings = DateFormatter.getDateSettings();

        if (dateSettings.convertToLocalDate) {
            return DateFormatter.formatDate(this.datePipe, this.event.startDateUTC);
        }
        else {
            return DateFormatter.formatDate(this.datePipe, this.event.startDate, this.event.timeZone);
        }
    }

    public getBannerImage() {
        // console.log('getBannerImage');
        if (this.event == null) {
            // console.log('getBannerImage: event==null');
            // This early exit avoids showing placeholder image while event isn't loaded.
            return '';
        }

        if (this.event.msevtmgt_eventimageurl != null) {
            return this.event.msevtmgt_eventimageurl;
        } else {
            if (environment.useRestStack === true) {
                return this.imageHelper.getImageUrl(this.defaultImageUrlSelfHosted);
            } else {
                return this.imageHelper.getImageUrl(this.defaultImageUrlCrmHosted);
            }
        }
    }

    public registerForSessions() {
        if (this.sessionCartService.getSessionCartForEvent(this.readableEventId).length !== 0) {
            this.router.navigate([EventCheckoutRoutePaths.REGISTRATION], { queryParams: { id: this.readableEventId } });
        } else {
            this.registerForAllSessions();
        }
    }

    public canUserRegister() {
        if (this.event.msevtmgt_setregistrationperiod) {
            let now = new Date(Date.now());
            let canReg=true;
            if (this.event.msevtmgt_registrationstartdate) canReg = canReg && (new Date(this.event.msevtmgt_registrationstartdate) < now);
            if (this.event.msevtmgt_registrationenddate)   canReg = canReg && (now < new Date(this.event.msevtmgt_registrationenddate));
            return canReg;
        }
        return true;
    }

    private registerForAllSessions() {
        this.sessions.forEach(session => {
            this.sessionCartService.addSession(this.readableEventId, session.id);
        });

        this.sessionCartService.isOpen = true;
    }

    private generateSessionByDay(): void {
        this.sessionsByDay = {};
        this.dateKeys = [];

        for (const session of this.sessions) {
            let startTime = new Date(session.startTime);
            const key = `${startTime.getMonth() +
                1}/${startTime.getDate()}/${startTime.getFullYear()}`;

            if (!this.sessionsByDay[key]) {
                this.sessionsByDay[key] = [];
                this.dateKeys.push(key);
            }

            this.sessionsByDay[key].push(session);
        }
        // if (this.dateKeys.length > 0) {
        //     this.selectedDateKey = this.dateKeys[0];
        // }
        // this.sessions = this.sessionsByDay[this.selectedDateKey];

        this.formattedDate = this.formatStartDate();
    }

    private dateText(dateKey: string): Observable<string> {

        const date = new Date(dateKey);
        const day = this.daysOfWeek[date.getDay()];        

        return this.labelsService.translateLabel(day).pipe(
            map(value => {
                return `${value}, ${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
            })
        );
    }

    private async getEventAndSessionData(): Promise<void> {
        // console.log("getEventAndSessionData");
        try {
            this.event = await this.activeEventService.getEvent(this.readableEventId).toPromise();
            // IF EVENT HAS REGISTRATION CLOSE DATE
            this.enableAnmeldungButton = true;
            this.nowDate = new Date().getTime();
            if (this.event) {
                this.eventDate = new Date(this.event.endDateUTC).getTime();
                if(this.nowDate > this.eventDate){
                    this.enableAnmeldungButton = false;
                }
            }
            if (this.event && this.enableAnmeldungButton && this.event.msevtmgt_setregistrationperiod) {
                const dateNotSet = new Date('0001-01-01T00:00:00.0000000Z').getSeconds();            
                if(this.event.msevtmgt_registrationenddate!=null){
                    // IF REGISTRATION CLOSED DATE HAS PASSED
                    this.eventDate = new Date(this.event.msevtmgt_registrationenddate).getTime();
                    if(this.eventDate < this.nowDate){
                        this.enableAnmeldungButton = false;
                        Swal.fire(
                            'Der Anmeldezeitraum für die Veranstaltung ist leider abgelaufen.',
                            `${this.event.websiteMessage}`,
                            'warning'
                            );
                    }
                }
                if (this.event.msevtmgt_registrationstartdate!=null) {
                    // IF REGISTRATION START DATE HAS NOT BEEN REACHED
                    this.eventDate = new Date(this.event.msevtmgt_registrationstartdate).getTime();
                    if(this.eventDate > this.nowDate){
                        this.enableAnmeldungButton = false;
                        Swal.fire(
                            'Der Anmeldezeitraum für die Veranstaltung wurde noch nicht erreicht.',
                            `${this.event.websiteMessage}`,
                            'warning'
                            );
                    }
                } 
            }
            
            this.sessions = await this.activeEventService.getSessions(this.readableEventId).toPromise();
            
            let allSpeakers = await this.eventService.getSpeakers(this.readableEventId).toPromise();
            const speakerMap: { [key: string]: Speaker } = {};
            for (const speaker of allSpeakers) { speakerMap[speaker.name] = speaker; }

            // update session imageURL
            for (var session of this.sessions) {
                for (var sessionSpeaker of session.speakers) {
                    const speaker = speakerMap[sessionSpeaker.name];
                    if (speaker && speaker.imageUrl) {
                        sessionSpeaker.imageUrl = speaker.imageUrl;
                    }
                }
            }


            let OverAll = this.sessions.filter( el => {
                return el.sessionType == 150170001;
            });
            this.sessions = this.sessions.filter( el => {
                return el.sessionType != 150170001;
            });
            // DISABLE THE SESSIONS WHICH ARE ONLY AVAILABLE WITH 'Gesamtteilnahme'
            this.sessions.map(el => {
                if(el.sessionType == 150170002){
                    el.userEligibleToRegister = true;
                }
            });

            this.sessionsCopy = this.sessions;

            this.OverAllSession = OverAll[0];            

            this.showSessions = this.sessions && this.sessions.length > 0;
            this.eventRouterService.emitSessions(this.sessions);
            // console.log("Event:- ", this.event);
            // console.log("Sessions:- ", this.sessions);

            this.generateSessionByDay();

            if (this.dateKeys.length > 0) {
                this.selectedDateKey = this.dateKeys[0];
            }
        } catch (error) {
            this.error = error;
            console.error(error);
        } finally {
            this.sessions = this.sessionsByDay[this.selectedDateKey];
            this.subscription = this.data.currentMessage.subscribe(message => {
                this.selectedSessions = message
                // console.log("SelectedSessioninEventComponent:- ", this.selectedSessions);
                
                // if(this.sessions && this.sessions.length>0 && this.selectedSessions.length>0){
                //     let sessionUpdate = this.sessions;
                //     for(let i=0; i<this.sessions.length; i++){
                //         for(let j=0; j<this.selectedSessions.length; j++){
                //             if(this.sessions[i].id == this.selectedSessions[j]){
                //                 sessionUpdate[i].alreadyRegistered = true;
                //             }
                //         }
                //     }
                //     this.sessions = sessionUpdate;
                // }
            
            })
        }
    }

    private async setIsSessionCartAllowed(): Promise<void> {
        const isFreeEvent = await this.activeEventService.isFreeEvent(this.readableEventId);
        const hasSessions = await this.activeEventService.hasEventSessions(this.readableEventId);

        this.isSessionCartAllowed = this.sessionCartService.isSessionCartEnabledForEvent(
            this.event,
            isFreeEvent,
            hasSessions
        );
    }
    public scroll(id) {
        this.vps.scrollToAnchor(id);
    }

    public getDateString(session: Session): string {
        let dateSettings = DateFormatter.getDateSettings();
        // if(dateSettings.convertToLocalDate){
        //     return DateFormatter.formatRangedDate(this.datePipe, session.startTimeUTC, session.endTimeUTC);
        // }
        // else {
        //     return DateFormatter.formatRangedDate(this.datePipe, session.startTime, session.endTime, session.timeZone);
        // }
        let d1Day = new Date(session.startTime).getDate(); // TO COMPARE STARTDATE
        let d2Day = new Date(session.endTime).getDate(); // TO COMPARE ENDDATE
        let d1 = this.datePipe.transform(session.startTime, 'dd. MMM yyyy, HH:mm '); // FORMATTED START DATE
        let d2 = this.datePipe.transform(session.endTime, 'dd. MMM yyyy, HH:mm '); // FORMATTED END DATE
        if(d1Day === d2Day){ // IF START & END DATE IS SAME THEN REMOVE DATE FROM ENDDATE AND SHOW TIME ONLY
            return (d1+'Uhr - '+d2.substring(13,20)+'Uhr');
        }
        else { // IF START & END DATE IS DIFFERENT THEN SHOW THE WHOLE DATE
            return (d1+'Uhr - '+d2+'Uhr');
        }

    }
    public async CheckedSession(val: any, session: any){
        let regAllowed = true; // FLAG TO CHECK THE SESSION IS RESTRICTED OR NOT BY DEFAULT NOT
        // ======================== OVERALL SESSION SELECTION ======================== //
        if(this.OverAllSession && val.target.value == this.OverAllSession.id){
            if(val.target.checked){ // IF CHECKED
                // CREATE COPY OF THE ASSOCIATED SESSION WITH OVERALL 
                this.sessionsCopy1 = this.sessionsCopy.filter( el => {
                    return el.sessionType == 150170002 || el.sessionType == 150170003;
                });
                // CREATE COPY OF THE SESSION NOT ASSOCIATED WITH OVERALL 
                let exclSelected = this.sessionsCopy.filter( el => {
                    return el.sessionType != 150170002 && el.sessionType != 150170003;
                });
                let sessionsWithSameDateTime: any = []; // INITIALIZE OBJECT FOR SAME TIME SESSIONS
                
                // ASSIGNED SAME TIME SESSIONS TO OBJECT
                for(let i=0; i<this.sessionsCopy1.length; i++){
                    for(let j=0; j<exclSelected.length; j++){
                        if(this.sessionsCopy1[i].startTime==exclSelected[j].startTime){
                            sessionsWithSameDateTime.push(exclSelected[j]);
                        }
                    }
                }
                // REMOVE THE CHECKED MARK OFF SELECTED GROUP SESSION IF OVERALL SESSSION IS SELECTED
                this.sessions.map(el => {
                    if(el.sessionType == 150170002 || el.sessionType == 150170003){
                        el.alreadyRegistered = false;
                    }
                });
                // REMOVE ANYOTHER GROUP SESSIONS FROM SELECTED SESSIONS IF OVERALL SESSION IS SELECTED
                for (let i=0; i<this.selectedSessions.length; i++){
                    for (let u=0; u<this.sessionsCopy1.length; u++){
                        if(this.selectedSessions[i] == this.sessionsCopy1[u].id){
                            this.selectedSessions.splice(i, 1);
                        }
                    }
                }
                // ADDING GROUP SESSIONS TO SELECTED SESSIONS OBJECT
                this.sessionsCopy1.forEach( el => {
                    this.selectedSessions.push(el.id);
                })
                // REMOVE THE ASSOCIATED SESSIONS FROM THE SESSIONS OBJECT WHEN SELECTED OVERALL
                this.sessions = this.sessionsCopy.filter(el => {
                    return el.sessionType != 150170002 && el.sessionType != 150170003;
                });

                // DISABLE THE OTHER SESSIONS WHICH HAS SAME DATETIME
                for(let u=0; u<sessionsWithSameDateTime.length; u++){
                    for(let i=0; i<this.sessions.length; i++){
                        if(sessionsWithSameDateTime[u].id == this.sessions[i].id){
                            this.sessions[i].userEligibleToRegister = true;
                        }
                    }
                }

                // AGAIN GENERATE THE SESSIONS BY DAY
                this.generateSessionByDay();
                // POPULATE DROP DOWN AGAIN
                this.sessions = this.sessionsByDay[this.selectedDateKey];
                // PASS THE SELECTED SESSIONS TO PAYPAL
                this.selectedSessions.push(val.target.value)
                if(this.selectedSessions && this.selectedSessions.length>1){
                    this.buttonFunctionality = 'Jahresversammlung';
                }
            }
            else if (!val.target.checked){ // IF UN-CHECKED
                // CREATE COPY OF THE ASSOCIATED SESSION WITH OVERALL 
                this.sessionsCopy1 = this.sessionsCopy.filter( el => {
                    return el.sessionType == 150170002 || el.sessionType == 150170003;
                });
                // CREATE COPY OF THE SESSION NOT ASSOCIATED WITH OVERALL 
                let exclSelected = this.sessionsCopy.filter( el => {
                    return el.sessionType != 150170002 && el.sessionType != 150170003;
                });
                let sessionsWithSameDateTime: any = []; // INITIALIZE OBJECT FOR SAME TIME SESSIONS
                
                // ASSIGNED SAME TIME SESSIONS TO OBJECT
                for(let i=0; i<this.sessionsCopy1.length; i++){
                    for(let j=0; j<exclSelected.length; j++){
                        if(this.sessionsCopy1[i].startTime==exclSelected[j].startTime){
                            sessionsWithSameDateTime.push(exclSelected[j]);
                        }
                    }
                }
                // REMOVE THE ASSOCIATED SESSIONS FROM THE SESSIONS OBJECT WHEN SELECTED OVERALL
                this.sessions = this.sessionsCopy.filter(el => {
                    return el.sessionType != 150170002 && el.sessionType != 150170003;
                });
                // ENABLE THE OTHER SESSIONS WHICH HAS SAME DATETIME
                for(let u=0; u<sessionsWithSameDateTime.length; u++){
                    for(let i=0; i<this.sessions.length; i++){
                        if(sessionsWithSameDateTime[u].id == this.sessions[i].id){
                            this.sessions[i].userEligibleToRegister = false;
                        }
                    }
                }
                // REMOVING GROUP SESSIONS TO SELECTED SESSIONS OBJECT
                this.sessionsCopy1.forEach( el => {
                    this.selectedSessions.splice(this.selectedSessions.indexOf(el.id), 1);
                })

                this.sessionsCopy1 = []; // REMOVE ALL THE SESSIONS FROM THIS

                // REMOVE THE DESELECTED SESSIONS FROM THE SELECTED SESSIONS OBJECT 
                this.selectedSessions = this.selectedSessions.filter(function(value, index, arr){ 
                    return value !== val.target.value;
                });
                // ASSIGN DEFAULT SESSIONS IN SESSIONS OBJECT
                this.sessions = this.sessionsCopy;
                // AGAIN GENERATE THE SESSIONS BY DAY
                this.generateSessionByDay();
                // POPULATE DROP DOWN AGAIN
                this.sessions = this.sessionsByDay[this.selectedDateKey];

                // CHECK FOR CHECKING REDIRECTION TO ANOTHER EVENT WHICH IS ONLY FOR "Mitgliederversammlung"
                this.redirectSessions();

            }
            // UPDATE THE SELECTED SESSIONS OBJECT
            this.data.changeMessage(this.selectedSessions)
            const selectedSessionsObjects = this.sessionsCopy.filter(el => this.selectedSessions.includes(el.id))
            let sessionsNames: any = [];
            selectedSessionsObjects.forEach( el => {
                sessionsNames.push(el.name)
            });
            this.data.changeName(sessionsNames);
            // console.log("nameofSessionObject:- ", sessionsNames);
            
        }
        // ========================== NORMAL SESSIONS SELECTIONS ========================== //
        else {
            if(val.target.checked){ // IF CHECKED
                let isSessionRestricted = session.isCapacityRestricted;
                let maxCapacity = session.maxCapacity;
                let regCount = session.registrationCount;

                if(isSessionRestricted){ // CHECKING IF SESSION IS RESTRICTED OR NOT
                    if(session.sessionType == 100000005){ // CHECK IF SESSION IS DEPENDENT WITH Kongresspacket
                        // CHECK IF Kongresspacket IS ALREADY SELECTED OR NOT
                        let overAllSessionAlreadySelected = this.selectedSessions.filter( el => {
                            return el == this.OverAllSession.id;
                        });
                        if(overAllSessionAlreadySelected && overAllSessionAlreadySelected.length>0){
                            await Swal.fire({ // DIALOGUE WILL APPEAR
                                title: 'Überprüfen der Sitzungskapazität!',
                                html: 'Bitte warten Sie...',
                                timer: 1200,
                                timerProgressBar: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                didOpen: () => {
                                    Swal.showLoading(null);
                                    if(regCount>=maxCapacity){
                                        regAllowed = false;
                                    }
                                },
                                willClose: () => { // IF MAX CAPACITY IS REACHED FOR THE SESSION
                                    if(regAllowed == false){
                                        Swal.fire(`${session.name}`, `Leider ist dieser Programmpunkt bereits ausgebucht.`, 'error');
                                        this.selectedSessions = this.selectedSessions.filter(el => el!=session.id);
                                        this.sessions.map(el => {                                    
                                            if(el.id == val.target.value){
                                                el.alreadyRegistered = false;
                                            }         
                                        });
                                        return;
                                    }
                                },
                            });
                        } else {
                            Swal.fire(`${session.name}`, `Dieser Programmpunkt ist nur buchbar mit dem Kongresspaket!`, 'error')
                                .then(res =>{
                                    this.selectedSessions = this.selectedSessions.filter(el => el!=session.id);
                                    this.sessions.map(el => {                                    
                                        if(el.id == val.target.value){
                                            el.alreadyRegistered = false;
                                        }         
                                    });
                                    return;
                                });
                        }
                    } else {
                        await Swal.fire({ // DIALOGUE WILL APPEAR
                            title: 'Überprüfen der Sitzungskapazität!',
                            html: 'Bitte warten Sie...',
                            timer: 1200,
                            timerProgressBar: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            didOpen: () => {
                                Swal.showLoading(null);
                                if(regCount>=maxCapacity){
                                    regAllowed = false;
                                }
                            },
                            willClose: () => { // IF MAX CAPACITY IS REACHED FOR THE SESSION
                                if(regAllowed == false){
                                    Swal.fire(`${session.name}`, `Leider ist dieser Programmpunkt bereits ausgebucht.`, 'error');
                                    this.selectedSessions = this.selectedSessions.filter(el => el!=session.id);
                                    this.sessions.map(el => {                                    
                                        if(el.id == val.target.value){
                                            el.alreadyRegistered = false;
                                        }         
                                    });
                                    return;
                                }
                            },
                        });
                    }
                    if(regAllowed==true){ // APPEND THE SESSION ID TO OBJECT IF CAPACITY NOT REACHED TO MAX
                        // PASS THE SELECTED SESSION ID
                        this.selectedSessions.push(val.target.value);
                    }
                    
                } else if (!isSessionRestricted) { // APPEND IF CAPACITY IS NOT RESTRICTED
                   
                    if(session.sessionType == 100000005){ // CHECK IF SESSION IS DEPENDENT WITH Kongresspacket

                        // CHECK IF Kongresspacket IS ALREADY SELECTED OR NOT
                        let overAllSessionAlreadySelected = this.selectedSessions.filter( el => {
                            return el == this.OverAllSession.id;
                        });
                        
                        if(overAllSessionAlreadySelected && overAllSessionAlreadySelected.length>0){
                          
                            this.selectedSessions.push(val.target.value);
                        } else {
                            await Swal.fire({ // DIALOGUE WILL APPEAR
                                title: 'Bitte warten Sie...',
                                timer: 1200,
                                timerProgressBar: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                didOpen: () => {
                                    Swal.showLoading(null);
                                    if(regCount>=maxCapacity){
                                        regAllowed = false;
                                    }
                                },
                                willClose: () => { // IF MAX CAPACITY IS REACHED FOR THE SESSION
                                    if(regAllowed == false){
                                        Swal.fire(`${session.name}`, `Dieser Programmpunkt ist nur buchbar mit dem Kongresspaket!`, 'error');
                                        this.selectedSessions = this.selectedSessions.filter(el => el!=session.id);
                                        this.sessions.map(el => {                                    
                                            if(el.id == val.target.value){
                                                el.alreadyRegistered = false;
                                            }         
                                        });
                                        return;
                                    }
                                },
                            });
                        }
                    } else{
                        // PASS THE SELECTED SESSION ID
                        this.selectedSessions.push(val.target.value);
                    }
                }
                // CHECK FOR CHECKING REDIRECTION TO ANOTHER EVENT WHICH IS ONLY FOR "Mitgliederversammlung"
                this.redirectSessions();

                // RETURN SELECTED SESSION COMPLETE OBJECT
                let Sel = this.sessions.filter( el => {
                    return el.id == val.target.value;
                });
                // RETURN THE SESSIONS WITH SAME DATE TIME
                let sessionsWithSameDateTime = this.sessions.filter(el=> {
                    return el.id != Sel[0].id && el.startTime == Sel[0].startTime
                });
                if(regAllowed==true){ // IF MAX CAPACITY IS NOT REACHED
                    // DISABLE THE SESSIONS WITH SAME DATE TIME
                    for(let u=0; u<sessionsWithSameDateTime.length; u++){
                        for(let i=0; i<this.sessions.length; i++){
                            if(sessionsWithSameDateTime[u].id == this.sessions[i].id){
                                this.sessions[i].userEligibleToRegister = true;
                            }
                        }
                    }
                }
                
            }
            else if (!val.target.checked){ // IF UN-CHECKED
                // RETURN SELECTED SESSION COMPLETE OBJECT
                let Sel = this.sessions.filter( el => {
                    return el.id == val.target.value;
                });
                // RETURN THE SESSIONS WITH SAME DATE TIME
                let sessionsWithSameDateTime = this.sessions.filter(el=> {
                    return el.id != Sel[0].id && el.startTime == Sel[0].startTime
                });
                // ENABLE THE SESSIONS WITH SAME DATE TIME
                for(let u=0; u<sessionsWithSameDateTime.length; u++){
                    for(let i=0; i<this.sessions.length; i++){
                        if(sessionsWithSameDateTime[u].id == this.sessions[i].id){
                            this.sessions[i].userEligibleToRegister = false;
                        }
                    }
                }
                // REMOVE THE DESELECTED SESSIONS FROM THE SELECTED SESSION OBJECT
                this.selectedSessions = this.selectedSessions.filter(function(value, index, arr){ 
                    return value !== val.target.value;
                });
                // CHECK FOR CHECKING REDIRECTION TO ANOTHER EVENT WHICH IS ONLY FOR "Mitgliederversammlung"
                this.redirectSessions();
            }
            // UPDATE THE SELECTED SESSIONS OBJECT
            this.data.changeMessage(this.selectedSessions)
            const selectedSessionsObjects = this.sessionsCopy.filter(el => this.selectedSessions.includes(el.id))
            let sessionsNames: any = [];
            selectedSessionsObjects.forEach( el => {
                sessionsNames.push(el.name)
            });
            this.data.changeName(sessionsNames);
            // console.log("nameofSessionObject:- ", sessionsNames);
        }
        
    }

    public updateSessionsView(val){
        // if(this.sessionsCopy1 && this.sessionsCopy1.length>0){
        //     this.sessions = this.sessions.filter(el => {
        //         return el.name != "Mitgliederversammlung" && el.name != "Gala Abend";
        //     });
        // }
        this.sessions = this.sessionsByDay[val];
        
    }
    public CollapseChange(val){
        this.valueCollapse = val;
        // console.log("Value:-", this.valueCollapse);
        
        this.isCollapsed = false;        
    }
    public translateLabel(translationKey: string, defaultValue: string): Observable<string> {
        return this.labelsService.translateLabel(translationKey, defaultValue);
    }

    public redirectSessions(){
        // RETURN SESSIONS IN WHICH REDIRECTION REQUIRED //
        var membersConference = this.sessionsCopy.filter( el => {
            return el.name == "Mitgliederversammlung (nur für Mitglieder)" 
            || el.name == "Gemeinsames Abendessen";
        });
        // IF SELECTED SESSION LENGTH IS 1 //
        if(this.selectedSessions && this.selectedSessions.length===1){  
            // CHECK IF SELECTION SESSION IS VALID SESSION FOR REDIRECTION //
            let lol = membersConference.filter(el => {
                return this.selectedSessions.includes(el.id);
            });
            if(lol.length==1){
                if(lol[0].name == 'Mitgliederversammlung (nur für Mitglieder)'){
                    this.buttonFunctionality = 'Mitgliederversammlung';
                } else if (lol[0].name == 'Gemeinsames Abendessen'){
                    this.buttonFunctionality = 'Einzelanmeldung';
                }
            } else {
                this.buttonFunctionality == 'Jahresversammlung';
            }
        } // IF SELECTED SESSION LENGTH IS 2 // 
        else if (this.selectedSessions && this.selectedSessions.length===2){
            // CHECK IF SELECTION SESSION IS VALID SESSION FOR REDIRECTION //
            let lol = membersConference.filter(el => {
                return this.selectedSessions.includes(el.id);
            });
            if(lol.length==2){    
                this.buttonFunctionality = 'Mitgliederversammlung';
            } else {
                this.buttonFunctionality == 'Jahresversammlung';
            }
        } else {
            this.buttonFunctionality = 'Jahresversammlung';
        }
    }
}


export enum EventQueryParameterNames {
    ReadableEventId = "id",
    SpeakerId = "speakerId"
}

export enum EventDetailSections {
    Sessions = "sessions",
    SessionTracks = "session-tracks",
    Speakers = "speakers",
    PassInformation = "pass-information"
}
